import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCandidateAccess, CandidateAccessDTO } from 'wisestep-api';
type GdprSettingsParam = {
  companyId: string;
  otp: string;
  email: string;
  companyName: string;
};

const useCandidateAccess = ({
  companyId,
  otp,
  email,
  companyName,
}: GdprSettingsParam): [CandidateAccessDTO | undefined, boolean] => {
  const [candidateAccessDTO, setCandidateAccessDTO] = useState<CandidateAccessDTO>();
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchCandidateAccess = async () => {
      setIsSuccess(false);
      try {
        const settingResponse = await getCandidateAccess(email ?? '', companyId ?? '', otp ?? '');
        const response = settingResponse.data;
        if (response) setCandidateAccessDTO(response);
      } catch (e) {
        navigate(`/data-protection/email/${companyName}/${companyId}`);
      }
      setIsSuccess(true);
    };
    fetchCandidateAccess();
  }, [email, otp, companyId, navigate, companyName]);
  return [candidateAccessDTO, isSuccess];
};
export default useCandidateAccess;
